import {Status} from '../reusables';
import {InvoiceOrderStatusTranslationsService} from 'src/app/shared/translations';

/**
 * Blueprint for the customer status object.
 */
export class InvoiceOrderStatus {
  public dispatched: string = 'dispatched';
  public printed: string = 'printed';
  public paid: string = 'paid';
  public reserved: string = 'R';
  public booked: string = 'B';
  public returned: string = 'Z';
  public statuses: Array<Status> = [
    {
      value: this.dispatched,
      status: this.statusTranslationsService.i18nDispatched,
      class: 'esf-tag--info'
    },
    {
      value: this.printed,
      status: this.statusTranslationsService.i18nPrinted,
      class: 'esf-tag--info'
    },
    {
      value: this.booked,
      status: this.statusTranslationsService.i18nBooked,
      class: 'esf-tag--success'
    },
    {
      value: this.reserved,
      status: this.statusTranslationsService.i18nReserved,
      class: 'esf-tag--info'
    },
    {
      value: this.paid,
      status: this.statusTranslationsService.i18nPaid,
      class:  'esf-tag--success'
    },
    {
      value: this.returned,
      status: this.statusTranslationsService.i18nReturned,
      class: 'esf-tag--alert'
    }
  ];

  constructor(private statusTranslationsService: InvoiceOrderStatusTranslationsService) {}

  /**
   * Get translated status
   */
  public getTranslatedInvoiceStatus(invoiceStatus: string): string {
    const translatedStatus = this.statuses.find((status: Status) => invoiceStatus === status.value);
    return translatedStatus ? translatedStatus.status : null;
  }

  /**
   * Get the correct class returned
   */
  public getStatusCssClass(invoiceStatus: string): any {
    const newStatus = this.statuses.find((status: Status) => invoiceStatus === status.value);
    return newStatus ? newStatus.class : null;
  }
}
